import actionCreatorFactory from 'typescript-fsa'
import { Api } from 'typescript-fetch-api'

const actionCreator = actionCreatorFactory('ParticipationSurvey')

export const actionSetParticipation = actionCreator<Api.ParticipationInfo>('actionSetParticipation')
export const actionSetParticipantSurvey = actionCreator<Api.ParticipationSurvey>('actionSetParticipantSurvey')
export const actionSetParticipations = actionCreator<Api.ParticipationInfo[]>('actionSetParticipations')
